// src/components/common/Footer.jsx
import React from "react";
import { Link } from "react-router-dom";
import SITE from "../../config/site";
import logo from "../../assets/logo.png";
import "./Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      {/* ── TOP: Brand + link columns ── */}
      <div className="footer-top">
        <div className="footer-content">
          {/* Brand column */}
          <div className="footer-brand">
            <Link to="/" className="footer-brand-mark">
              <img
                src={logo}
                alt=""
                className="footer-brand-logo-img"
                aria-hidden="true"
              />
              <span className="footer-brand-name">{SITE.brand.name}</span>
            </Link>

            <p className="footer-brand-tag">{SITE.brand.tagline}</p>

            <div className="footer-social" aria-label="Social links">
              <a
                href={SITE.social.twitter}
                className="footer-social-link"
                aria-label="Twitter"
                target="_blank"
                rel="noreferrer"
              >
                <i className="fa-brands fa-x-twitter" />
              </a>
              <a
                href={SITE.social.facebook}
                className="footer-social-link"
                aria-label="Facebook"
                target="_blank"
                rel="noreferrer"
              >
                <i className="fa-brands fa-facebook-f" />
              </a>
              <a
                href={SITE.social.linkedin}
                className="footer-social-link"
                aria-label="LinkedIn"
                target="_blank"
                rel="noreferrer"
              >
                <i className="fa-brands fa-linkedin-in" />
              </a>
              <a
                href={SITE.social.youtube}
                className="footer-social-link"
                aria-label="YouTube"
                target="_blank"
                rel="noreferrer"
              >
                <i className="fa-brands fa-youtube" />
              </a>
              <a
                href={SITE.social.whatsapp}
                className="footer-social-link"
                aria-label="WhatsApp"
                target="_blank"
                rel="noreferrer"
              >
                <i className="fa-brands fa-whatsapp" />
              </a>
            </div>
          </div>

          {/* Platform column */}
          <nav className="footer-col" aria-label="Platform">
            <h4 className="footer-col-title">Platform</h4>
            <ul className="footer-links">
              <li>
                <Link to="/courses">Courses</Link>
              </li>
              <li>
                <Link to="/store">Store</Link>
              </li>
              <li>
                <Link to="/about">About us</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </nav>

          {/* Contact column */}
          <div className="footer-col">
            <h4 className="footer-col-title">Contact</h4>
            <ul className="footer-contact">
              <li>
                <i className="fa-solid fa-envelope" aria-hidden="true" />
                <a href={`mailto:${SITE.contact.email}`}>
                  {SITE.contact.email}
                </a>
              </li>
              <li>
                <i className="fa-solid fa-phone" aria-hidden="true" />
                <a href={`tel:${SITE.contact.phoneRaw}`}>
                  {SITE.contact.phoneDisplay}
                </a>
              </li>
              <li>
                <i className="fa-solid fa-location-dot" aria-hidden="true" />
                <span>{SITE.contact.location}</span>
              </li>
              <li>
                <i className="fa-regular fa-clock" aria-hidden="true" />
                <span>{SITE.contact.hours}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* ── MIDDLE: Trust strip ── */}
      <div className="footer-trust">
        <div className="footer-trust-inner">
          <div className="footer-trust-item">
            <i className="fa-solid fa-shield-halved" aria-hidden="true" />
            <span>Secure payments</span>
          </div>
          <div className="footer-trust-item">
            <i className="fa-solid fa-truck-fast" aria-hidden="true" />
            <span>Countrywide delivery</span>
          </div>
          <div className="footer-trust-item">
            <i className="fa-solid fa-headset" aria-hidden="true" />
            <span>Human support</span>
          </div>
          <div className="footer-trust-item">
            <i className="fa-solid fa-certificate" aria-hidden="true" />
            <span>Certified courses</span>
          </div>
        </div>
      </div>

      {/* ── BOTTOM: Legal ── */}
      <div className="footer-bottom">
        <div className="footer-bottom-inner">
          <p className="footer-copy">
            &copy; {currentYear} {SITE.brand.name}. All rights reserved.
          </p>

          <ul className="footer-legal">
            <li>
              <Link to="/privacy">Privacy</Link>
            </li>
            <li>
              <Link to="/terms">Terms</Link>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;